module.exports = __webpack_public_path__ + "img/202305220001_1280_toHome.0fff8e15.jpg";